<div class="order-detail-container">
    @if (loading) {
        <div class="loading-container">
            <p-progressBar mode="indeterminate"></p-progressBar>
            <p class="text-center mt-3">Cargando detalle de orden...</p>
        </div>
    }

    @if (!loading && orderDetail) {
        <!-- Información General -->
        <div class="grid mb-4">
            <div class="col-12">
                <p-card>
                    <div class="grid">
                        <div class="col-12 md:col-6">
                            <div class="fieldline">
                                <span class="font-semibold">Paciente:</span>
                                <p class="mt-1">{{ orderDetail.nameOrder }}</p>
                            </div>
                            <div class="fieldline">
                                <span class="font-semibold">Sucursal:</span>
                                <p class="mt-1">{{ orderDetail.branchOrder }}</p>
                            </div>
                            <div class="fieldline">
                                <span class="font-semibold">Doctor:</span>
                                <div class="flex align-items-center gap-2 mt-1">
                                    <p class="m-0">{{ orderDetail.doctorNameOrder }}</p>
                                    <button pButton icon="pi pi-user-edit" size="small" severity="secondary" [text]="true" [rounded]="true" pTooltip="Cambiar doctor" (click)="openChangeDoctorModal()"></button>
                                </div>
                            </div>

                            @if (orderDetail.isSecure) {
                                <div class="fieldline">
                                    <span class="font-semibold">Seguro:</span>
                                    <div class="flex align-items-center gap-2 mt-1">
                                        <p class="m-0">{{ orderDetail.secure }}</p>
                                        @if (haveRole('Root')) {
                                            <button pButton icon="pi pi-shield" size="small" severity="secondary" [text]="true" [rounded]="true" pTooltip="Cambiar seguro" (click)="openChangeInsuranceModal()"></button>
                                        }
                                    </div>
                                </div>
                                <div class="fieldline">
                                    <span class="font-semibold">Sucursal:</span>
                                    <p>{{ orderDetail.subsidiarySecure }}</p>
                                </div>
                            }
                        </div>

                        <div class="col-12 md:col-3">
                            <div class="fieldline">
                                <span class="font-semibold">Edad:</span>
                                <p class="mt-1">{{ orderDetail.agePatientOrder }}</p>
                            </div>
                            <div class="fieldline">
                                <span class="font-semibold">CI:</span>
                                <p class="mt-1">{{ orderDetail.ciOrder }}</p>
                            </div>
                            <div class="fieldline">
                                <span class="font-semibold">Género:</span>
                                <p class="mt-1">{{ orderDetail.genderOrder }}</p>
                            </div>
                            <div class="fieldline">
                                <span class="font-semibold">Estado:</span>
                                <div class="mt-1">
                                    <p-tag
                                        [value]="
                                            getOrderStatusCodeById(orderDetail.statusOrder) === 'PENDING'
                                                ? 'Pendiente'
                                                : getOrderStatusCodeById(orderDetail.statusOrder) === 'IN_PROGRESS'
                                                  ? 'En proceso'
                                                  : getOrderStatusCodeById(orderDetail.statusOrder) === 'INCOMPLETE'
                                                    ? 'Incompleto'
                                                    : getOrderStatusCodeById(orderDetail.statusOrder) === 'COMPLETED'
                                                      ? 'Completado'
                                                      : getOrderStatusCodeById(orderDetail.statusOrder) === 'CANCEL'
                                                        ? 'Cancelado'
                                                        : getOrderStatusCodeById(orderDetail.statusOrder)
                                        "
                                        [severity]="
                                            getOrderStatusCodeById(orderDetail.statusOrder) === 'PENDING'
                                                ? 'danger'
                                                : getOrderStatusCodeById(orderDetail.statusOrder) === 'IN_PROGRESS'
                                                  ? 'warn'
                                                  : getOrderStatusCodeById(orderDetail.statusOrder) === 'INCOMPLETE'
                                                    ? 'warn'
                                                    : getOrderStatusCodeById(orderDetail.statusOrder) === 'COMPLETED'
                                                      ? 'success'
                                                      : getOrderStatusCodeById(orderDetail.statusOrder) === 'CANCEL'
                                                        ? 'secondary'
                                                        : 'info'
                                        "
                                    ></p-tag>
                                </div>
                            </div>
                            <div class="fieldline">
                                <span class="font-semibold">Lateral:</span>
                                <p class="mt-1">{{ orderDetail.hasLateral ? 'Sí' : 'No' }}</p>
                            </div>
                        </div>
                        <div class="col-12 md:col-3">
                            <div class="fieldline">
                                <span class="font-semibold">Fecha:</span>
                                <p class="mt-1">{{ orderDetail.dateOrder }}</p>
                            </div>
                            <div class="fieldline">
                                <span class="font-semibold">Hora:</span>
                                <p class="mt-1">{{ orderDetail.timeOrder }}</p>
                            </div>
                            <div class="fieldline">
                                <span class="font-semibold">Fecha de Entrega:</span>
                                <p class="mt-1">{{ orderDetail.deliveryDateOrder }}</p>
                            </div>
                            <div class="fieldline">
                                <span class="font-semibold">Prioridad:</span>
                                <p class="mt-1">{{ orderDetail.priorityOrder }}</p>
                            </div>
                        </div>
                    </div>

                    <!-- Información de Pagos -->
                    <p-divider></p-divider>
                    <div class="grid">
                        <div class="col-12">
                            <h3 class="text-lg font-semibold mb-3"><i class="pi pi-wallet mr-2"></i>Información de Pago</h3>
                        </div>
                        <div class="col-12 md:col-3">
                            <div class="field">
                                <span class="font-semibold">Monto Paciente:</span>
                                <p class="mt-1 text-lg">{{ formatCurrency(orderDetail.amountpatient) }}</p>
                            </div>
                        </div>
                        <div class="col-12 md:col-3">
                            <div class="field">
                                <span class="font-semibold">Monto Seguro:</span>
                                <p class="mt-1 text-lg">{{ formatCurrency(orderDetail.amountsecure) }}</p>
                            </div>
                        </div>
                        <div class="col-12 md:col-3">
                            <div class="field">
                                <span class="font-semibold">Estado de Pago:</span>
                                <div class="mt-1">
                                    <p-tag [value]="orderDetail.isPaid ? 'Pagado' : 'Pendiente'" [severity]="orderDetail.isPaid ? 'success' : 'danger'"> </p-tag>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 md:col-3">
                            <div class="field">
                                <span class="font-semibold">Factura:</span>
                                <div class="mt-1">
                                    <p-tag [value]="orderDetail.hasInvoice ? 'Sí' : 'No'" [severity]="orderDetail.hasInvoice ? 'success' : 'secondary'"> </p-tag>
                                </div>
                            </div>
                        </div>
                    </div>
                </p-card>
            </div>
        </div>

        <!-- Estudios -->
        <div class="grid">
            <div class="col-12">
                <p-card>
                    <div class="flex align-items-center justify-content-between mb-3">
                        <h3 class="text-lg font-semibold"><i class="pi pi-list mr-2"></i>Estudios</h3>
                    </div>

                    @if (studies.length > 0) {
                        <p-table [value]="studies" [rowHover]="true" [tableStyle]="{ 'min-width': '50rem' }" styleClass="p-datatable-sm">
                            <ng-template pTemplate="header">
                                <tr>
                                    <th id="code">Código</th>
                                    <th id="namestudy">Nombre del Estudio</th>
                                    <th id="status">Estado</th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-study>
                                <tr>
                                    <td>{{ study.codStudy }}</td>
                                    <td>{{ study.nameStudy }}</td>
                                    <td>
                                        <p-tag
                                            [value]="
                                                getStatusCodeById(study.statusStudy) === 'PENDING'
                                                    ? 'Pendiente'
                                                    : getStatusCodeById(study.statusStudy) === 'IN_PROGRESS'
                                                      ? 'En proceso'
                                                      : getStatusCodeById(study.statusStudy) === 'COMPLETED'
                                                        ? 'Completado'
                                                        : getStatusCodeById(study.statusStudy) === 'SENT'
                                                          ? 'Enviado'
                                                          : getStatusCodeById(study.statusStudy) === 'PENDING_LAB'
                                                            ? 'Pendiente en Laboratorio'
                                                            : getStatusCodeById(study.statusStudy) === 'IN_PROGRESS_LAB'
                                                              ? 'En proceso en Laboratorio'
                                                              : getStatusCodeById(study.statusStudy) === 'COMPLETED_LAB'
                                                                ? 'Completado en Laboratorio'
                                                                : getStatusCodeById(study.statusStudy) === 'SENT_LAB'
                                                                  ? 'Enviado'
                                                                  : getStatusCodeById(study.statusStudy)
                                            "
                                            [severity]="
                                                getStatusCodeById(study.statusStudy) === 'PENDING'
                                                    ? 'danger'
                                                    : getStatusCodeById(study.statusStudy) === 'IN_PROGRESS'
                                                      ? 'warn'
                                                      : getStatusCodeById(study.statusStudy) === 'COMPLETED'
                                                        ? 'success'
                                                        : getStatusCodeById(study.statusStudy) === 'SENT'
                                                          ? 'info'
                                                          : getStatusCodeById(study.statusStudy) === 'PENDING_LAB'
                                                            ? 'danger'
                                                            : getStatusCodeById(study.statusStudy) === 'IN_PROGRESS_LAB'
                                                              ? 'warn'
                                                              : getStatusCodeById(study.statusStudy) === 'COMPLETED_LAB'
                                                                ? 'success'
                                                                : getStatusCodeById(study.statusStudy) === 'SENT_LAB'
                                                                  ? 'info'
                                                                  : 'info'
                                            "
                                        ></p-tag>
                                    </td>
                                </tr>
                            </ng-template>
                        </p-table>
                    }

                    @if (studies.length === 0) {
                        <div class="text-center py-4">
                            <i class="pi pi-inbox text-4xl text-gray-400"></i>
                            <p class="text-gray-600 mt-2">No hay estudios registrados para esta orden</p>
                        </div>
                    }
                </p-card>
            </div>
        </div>
    }

    @if (!loading && !orderDetail) {
        <div class="text-center py-6">
            <i class="pi pi-exclamation-triangle text-6xl text-orange-500"></i>
            <p class="text-xl mt-3">No se pudo cargar el detalle de la orden</p>
        </div>
    }
</div>

<!-- ================================================================ -->
<!-- MODAL: CAMBIO DE DOCTOR                                           -->
<!-- ================================================================ -->
<p-dialog header="Cambiar Doctor de la Orden" [(visible)]="showChangeDoctorModal" [closable]="true" [draggable]="false" [resizable]="false" [style]="{ width: '800px' }" (onHide)="closeChangeDoctorModal()">
    @if (orderDetail) {
        <div class="flex align-items-center gap-2 p-2 mb-3 border-round bg-gray-50">
            <i class="pi pi-info-circle text-blue-500"></i>
            <span class="text-sm text-gray-600">
                Doctor actual: <strong>{{ orderDetail.doctorNameOrder }}</strong>
            </span>
        </div>
    }

    <form [formGroup]="doctorSearchForm" class="mb-4">
        <div class="form-field">
            <label for="namedocSearch">Nombre, Apellido o Nº de Registro</label>
            <div class="flex gap-2 mt-1">
                <input pInputText id="namedocSearch" formControlName="namedoctor" placeholder="Ej: JUAN PEREZ" class="flex-1" (keyup.enter)="searchnameDoctor()" />
                <button pButton icon="pi pi-search" label="Buscar" [loading]="searchingDoctor" [disabled]="doctorSearchForm.invalid" (click)="searchnameDoctor()"></button>
            </div>
            @if (doctorSearchForm.get('namedoctor')?.invalid && doctorSearchForm.get('namedoctor')?.touched) {
                <small class="p-error">Mínimo 3 caracteres requeridos</small>
            }
        </div>
    </form>

    @if (searchPerformedDoctor && !searchingDoctor) {
        <div>
            @if (doctorsResults.length > 0) {
                <p-message severity="success" [text]="doctorsResults.length + ' doctor(es) encontrado(s)'" class="mb-3"></p-message>
            }
            @if (doctorsResults.length === 0) {
                <p-message severity="warn" text="No se encontraron doctores" class="mb-3"></p-message>
            }

            @if (doctorsResults.length > 0) {
                <p-table [value]="doctorsResults" selectionMode="single" [(selection)]="selectedNewDoctor" styleClass="p-datatable-sm p-datatable-hoverable-rows mb-3" [scrollable]="true" scrollHeight="250px">
                    <ng-template pTemplate="header">
                        <tr>
                            <th id="nameDoctor">Nombre</th>
                            <th id="register">Registro</th>
                            <th id="email">Correo</th>
                            <th id="selectDoctor" style="width: 80px" class="text-center">Sel.</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-doc>
                        <tr [pSelectableRow]="doc" [class.selected-row]="selectedNewDoctor?.idDoctor === doc.idDoctor">
                            <td>{{ doc.name }} {{ doc.lastname }}</td>
                            <td>{{ doc.registrationNumber }}</td>
                            <td>
                                @if (doc.email) {
                                    <span><i class="pi pi-envelope mr-1"></i>{{ doc.email }}</span>
                                } @else {
                                    <span class="text-gray-400 text-sm">Sin correo</span>
                                }
                            </td>
                            <td class="text-center">
                                <button
                                    pButton
                                    icon="pi pi-check"
                                    size="small"
                                    [severity]="selectedNewDoctor?.idDoctor === doc.idDoctor ? 'success' : 'info'"
                                    [outlined]="selectedNewDoctor?.idDoctor !== doc.idDoctor"
                                    pTooltip="Seleccionar"
                                    (click)="selectNewDoctor(doc)"
                                ></button>
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            }

            <button pButton label="Crear Nuevo Doctor" icon="pi pi-user-plus" severity="secondary" [outlined]="true" (click)="openDoctorCreateModal()" class="w-full mt-2"></button>
        </div>
    }

    @if (selectedNewDoctor) {
        <div class="mt-3 p-3 border-round" style="background: #f0fdf4; border: 1px solid #86efac">
            <div class="flex align-items-center gap-2">
                <i class="pi pi-check-circle text-green-500" style="font-size: 1.2rem"></i>
                <div>
                    <div class="font-bold">{{ selectedNewDoctor.name }} {{ selectedNewDoctor.lastname }}</div>
                    <div class="text-sm">
                        <i class="pi pi-envelope mr-1"></i>
                        {{ selectedNewDoctor.email || 'Sin correo registrado' }}
                    </div>
                </div>
            </div>
            @if (!selectedNewDoctor.email) {
                <p-message severity="warn" text="El doctor seleccionado no tiene correo. El envío podría fallar." class="mt-2 w-full"></p-message>
            }
        </div>
    }

    <ng-template pTemplate="footer">
        <button pButton label="Cancelar" icon="pi pi-times" severity="secondary" [text]="true" (click)="closeChangeDoctorModal()"></button>
        <button pButton label="Confirmar Cambio de Doctor" icon="pi pi-check" severity="success" [loading]="updatingDoctor" [disabled]="!selectedNewDoctor || updatingDoctor" (click)="confirmDoctorChange()"></button>
    </ng-template>
</p-dialog>

<!-- ================================================================ -->
<!-- MODAL: CREAR DOCTOR (sub-modal)                                   -->
<!-- ================================================================ -->
<p-dialog header="Crear Nuevo Doctor" [(visible)]="showDoctorCreateModal" [closable]="true" [draggable]="false" [resizable]="false" [style]="{ width: '560px' }">
    <form [formGroup]="doctorForm">
        <div class="form-grid">
            <div class="form-field col-span-6">
                <label for="dcName">Nombre *</label>
                <input pInputText id="dcName" formControlName="name" class="w-full" style="text-transform: uppercase" />
            </div>
            <div class="form-field col-span-6">
                <label for="dcLastname">Apellido *</label>
                <input pInputText id="dcLastname" formControlName="lastname" class="w-full" style="text-transform: uppercase" />
            </div>
            <div class="form-field col-span-6">
                <label for="dcRegNumber">Nº de Registro *</label>
                <input pInputText id="dcRegNumber" formControlName="registrationNumber" class="w-full" />
            </div>
            <div class="form-field col-span-6">
                <label for="dcSpecialty">Especialidad *</label>
                <p-select id="dcSpecialty" formControlName="specialty" [options]="specialty" optionLabel="label" optionValue="id" class="w-full" appendTo="body"></p-select>
            </div>
            <div class="form-field col-span-6">
                <label for="dcGender">Género *</label>
                <p-select id="dcGender" formControlName="gender" [options]="gender" optionLabel="label" optionValue="id" placeholder="Seleccione" class="w-full" appendTo="body"></p-select>
            </div>
            <div class="form-field col-span-6">
                <label for="dcPhone">Teléfono</label>
                <input pInputText id="dcPhone" formControlName="phone" class="w-full" />
            </div>
            <div class="form-field col-span-12">
                <label for="dcEmail">Email <span class="text-sm text-gray-500">(requerido para envío)</span></label>
                <input pInputText id="dcEmail" type="email" formControlName="email" class="w-full" />
            </div>
        </div>
    </form>
    <ng-template pTemplate="footer">
        <button pButton label="Cancelar" icon="pi pi-times" severity="secondary" [text]="true" (click)="showDoctorCreateModal = false"></button>
        <button pButton label="Guardar y Seleccionar" icon="pi pi-check" severity="success" [loading]="savingDoctor" [disabled]="doctorForm.invalid || savingDoctor" (click)="saveDoctorAndSelect()"></button>
    </ng-template>
</p-dialog>

<!-- ================================================================ -->
<!-- MODAL: CAMBIO DE SEGURO                                           -->
<!-- ================================================================ -->
<p-dialog header="Cambiar Seguro de la Orden" [(visible)]="showChangeInsuranceModal" [closable]="true" [draggable]="false" [resizable]="false" [style]="{ width: '600px' }" (onHide)="closeChangeInsuranceModal()">
    @if (orderDetail) {
        <div class="flex align-items-center gap-2 p-2 mb-3 border-round bg-gray-50">
            <i class="pi pi-info-circle text-blue-500"></i>
            <span class="text-sm text-gray-600">
                Seguro actual: <strong>{{ orderDetail.secure }}</strong>
                @if (orderDetail.subsidiarySecure) {
                    <span>
                        | Sucursal: <strong>{{ orderDetail.subsidiarySecure }}</strong></span
                    >
                }
            </span>
        </div>
    }

    <div class="mb-4">
        <div class="form-field">
            <label for="secureSelect">Seguro</label>
            <p-select
                id="secureSelect"
                [(ngModel)]="selectedNewSecure"
                [options]="secures"
                optionLabel="name"
                placeholder="Seleccione o busque un seguro"
                (onChange)="onSecureChange($event.value)"
                [showClear]="true"
                [filter]="true"
                filterBy="name,code"
                [filterPlaceholder]="'Buscar...'"
                [loading]="loadingSecures"
                class="w-full"
                appendTo="body"
                [virtualScroll]="true"
                [virtualScrollItemSize]="58"
                [virtualScrollOptions]="{ itemSize: 58 }"
            >
                <ng-template pTemplate="selectedItem">
                    @if (selectedNewSecure) {
                        <div class="flex align-items-center gap-2">
                            <i class="pi pi-shield text-primary"></i>
                            <div>
                                <div class="font-bold">{{ selectedNewSecure.name }}</div>
                            </div>
                        </div>
                    }
                </ng-template>
                <ng-template let-secure pTemplate="item">
                    <div class="flex align-items-center gap-2">
                        <i class="pi pi-shield text-primary"></i>
                        <div>
                            <div class="font-bold">{{ secure.name }}</div>
                            <div class="text-xs text-gray-500">{{ secure.code }}</div>
                        </div>
                    </div>
                </ng-template>
            </p-select>
        </div>
    </div>

    @if (selectedNewSecure && !loadingSubsidiaries) {
        <div class="mb-4">
            <div class="form-field">
                <label for="subsidiarySelect">Sucursal</label>
                <p-select
                    id="subsidiarySelect"
                    [(ngModel)]="selectedNewSubsidiary"
                    [options]="subsidiaries"
                    optionLabel="name"
                    placeholder="Seleccione una sucursal"
                    [filter]="true"
                    filterBy="name,code"
                    [showClear]="true"
                    class="w-full"
                    appendTo="body"
                    [virtualScroll]="true"
                    [virtualScrollItemSize]="58"
                    [virtualScrollOptions]="{ itemSize: 58 }"
                >
                    <ng-template let-sub pTemplate="item">
                        <div class="flex align-items-center gap-2">
                            <i class="pi pi-building text-primary"></i>
                            <div>
                                <div class="font-bold">{{ sub.name }}</div>
                                <div class="text-xs text-gray-500">{{ sub.code }}</div>
                            </div>
                        </div>
                    </ng-template>
                </p-select>
                @if (subsidiaries.length === 0) {
                    <small class="text-gray-500">Este seguro no tiene sucursales disponibles</small>
                }
            </div>
        </div>
    }

    @if (loadingSubsidiaries) {
        <div class="flex align-items-center gap-2 mb-4 p-2">
            <i class="pi pi-spin pi-spinner text-primary"></i>
            <span class="text-sm text-gray-600">Cargando sucursales...</span>
        </div>
    }

    <ng-template pTemplate="footer">
        <button pButton label="Cancelar" icon="pi pi-times" severity="secondary" [text]="true" (click)="closeChangeInsuranceModal()"></button>
        <button pButton label="Confirmar Cambio de Seguro" icon="pi pi-check" severity="success" [loading]="updatingInsurance" [disabled]="!selectedNewSecure || updatingInsurance" (click)="confirmInsuranceChange()"></button>
    </ng-template>
</p-dialog>
